import {
    OBJECT_LIST_REQUESTED,
    OBJECT_LIST_RECEIVED,
    OBJECT_LIST_ERROR
} from '../actions/objectList.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const objectList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case OBJECT_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case OBJECT_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.objectList, action.receivedAt);
        case OBJECT_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
